module.exports = {
    "collapse": `D\xf6lj`,
    "expand": `Expandera`
};


//# sourceMappingURL=sv-SE.main.js.map
